import { render } from "./small-page.vue?vue&type=template&id=41adcd64&scoped=true"
import script from "./small-page.vue?vue&type=script&lang=js"
export * from "./small-page.vue?vue&type=script&lang=js"

import "./small-page.vue?vue&type=style&index=0&id=41adcd64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41adcd64"]])

export default __exports__